import React from 'react';

import ArgoIcon from '../../images/icons/argocd.svg';

export const ArgoCDLogo = () => {
  return <img height="18" src={ArgoIcon} alt="ArgoCD logo" />;
};
